'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

import { useToggle } from '@nf/utils-common/hooks';
import { uiService } from '@/services/ui.service';

import { Modal } from '@/components/widgets/modal';
import { LeagueFilter } from '@/features/league-filter';

export const LeagueFilterModal = () => {
	const t = useTranslations('General');
	const [isOpen, toggleIsOpen, setIsOpen,] = useToggle();

	const closeModel = () => setIsOpen(false);

	useEffect(() => {
		uiService.onLeagueFilterDisplay$.subscribe(isLeagueFilterOpen => {
			setIsOpen(isLeagueFilterOpen);
		});
	}, []);

	return (
		<Modal 
			isOpen={isOpen}
			variant="top"
			title={t('lbl_selectleague')}
			closeModal={closeModel}
		>
			<LeagueFilter />
		</Modal>
	);
};